import { Box, Typography, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import { useEffect } from "react";
import CustomUserCard from "../events/components/CustomUserCard";
import "@fontsource/rubik";
import AuthLayout from "../layouts/AuthLayout";
import useConsentDetail from "../events/hooks/useConsentDetail";
import EventDetailCard from "../events/components/EventDetailCard";
import FilmingTutorialCard from "../events/components/FilmingTutorialCard";
import SubmitChangeRequestCard from "./components/SubmitChangeRequestCard";
import FinalVideoCompletedCard from "./components/FinalVideoCompletedCard";
import { updateReviewState } from "../../redux/reviewSlice";
import PopupVideoPlayer from "../../components/PopupVideoPlayer";
import { updateState } from "../../redux/commonSlice";
import VideoEditedCompletedCard from "./components/VideoEditedCompletedCard";
import ReEditingStartedCard from "./components/ReEditingStartedCard";
import SubmitChangeRequestTutorialPopup from "./components/SubmitChangeRequestTutorialPopup";
import { checkNewVideoArrival, getEventDetails, viewProjectMembers } from "../events/actions";
import { getUserRoles } from "../../commonactions/actions";
import { setSnackbar } from "../../redux/messageSlice";
import { PERMISSION } from "../../constants/constants";
import usePermissions from "../../hooks/usePermissions";
import ProjectMembersCard from "../events/components/ProjectMembersCard";
import InviteProjectMembersPopup from "../events/components/InviteProjectMembersPopup";
import ViewProjectMembersPopup from "../events/components/ViewProjectMembersPopup";
import AssignOwnerPopup from "../events/components/AssignOwnerPopup";
import RemoveUserConfirmationPopup from "../events/components/RemoveUserConfirmationPopup";
import RemoveOwnerPopup from "../events/components/RemoveOwnerPopup";
import UploadDocumentsPopup from "../events/components/UploadDocumentsPopup";
import UploadSongPopup from "../events/components/UploadSongPopup";
import { checkTokenSession } from "../dashboard/actions";
import { createNewRevision, disableRevisionTutorialRequest } from "./actions";
import RevisionReviewCard from "./components/RevisionReviewCard";
// Entry point is hidden for now; the popup stays wired so it can be switched back on.
import RevisionHistoryPopup from "./components/RevisionHistoryPopup";
import useGuestAccess from "../../hooks/useGuestAccess";



const useStyles = makeStyles((theme) => ({
    container: {
      display:'flex',
      width:'100%',
      minWidth:'860px',
       height:'85vh',
     // height:'100%',  
  },
    center: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly'
    },
    leftContainer: {
         width:'21.1%',
          display:'flex',
          flexDirection:'column',
          justifyContent: 'flex-start',
          marginBottom:'41px',  
         // paddingLeft:'2.24%',
          height:'100%',
        
    },
    rightContainer:{
      width:'77.2%',
      display:'flex',
      flexDirection:'column',
     // marginRight:'4.9%',
      marginBottom:'51px',
      marginLeft:'1.7%',
      height:'100%',
     
  },
    scroll: {
      overflowY: 'scroll',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
  
    }
  }));

const CompletedEventPage = (props) => {
  const {uploadProps} = props;

  const {
    selectedFiles, setSelectedFiles,
    uploadsInProgress, setUploadsInProgress,
    uploadStatus, setUploadStatus,
    progress, setProgress, uploadFiles,
    requestController, setRequestController,
    actionAfterSuccessfulUpload
  } = uploadProps;
    const classes = useStyles()
    // const { videoTitle, videoSrc, } = props
    const [copyButtonText, setCopyButtonText] = useState("COPY LINK");
    const [shareButtonText, setShareButtonText] = useState("INVITE");
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [hasPermission] = usePermissions();
  
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const teamsReducer = useSelector((state) => state.root.teamsReducer);
    const projectReducer = useSelector((state) => state.projectReducer);
    const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
    const permissionsReducer = useSelector((state) => state.permissionsReducer);
   // const [refetchEventDetail] = useEventDetails(commonReducer.production_event_id)
    const [eventData, setEventData] = useState({})
    // KAN-10: same query key as SubmitChangeRequestCard, so react-query serves
    // both from one request.
    const { guestReviewUrl } = useGuestAccess(commonReducer?.production_event_id)
    // const [uploadedVideosArray, setUploadedVideosArray] = useState([]);
    // const [checkVideoArrival, recheckVideoArrival] = useCheckVideoArrival();
    // const [uploadedVideos, refetchList] = useUploadedList(true);
    const [getConsentDetails] = useConsentDetail();
    const statusRef = useRef();
    const finalVideoRef = useRef();
    const underRevisionRef = useRef(false)
    const isFromTeamsDashboard =  !!teamsReducer.selected_team ? true : false;
    const backButtonTitle = isFromTeamsDashboard ? "Back to Team Dashboard" : "Back to Main Dashboard";
    const [showPage, setShowPage] = useState(false)

    const event = !!teamsReducer.selected_team ? teamsReducer.events?.find((event) => event.id == commonReducer.production_event_id) : commonReducer.events?.find((event) => event.id == commonReducer.production_event_id)

    // const { files, 
    //   setFiles,
    //   progress, 
    //   uploadStatus,
    //   setUploadStatus, 
    //   setProgress,
    //   isLoading,
    //   requestController, 
    //   setRequestController,
    //   stopUpload, 
    //   stopList } = useSequentialVideoUpload(commonReducer.production_event_id, false, uploadedVideos)  // useSequentialVideoUpload(eventId: , isGuestUser, uploadedVideos) 

   
     
     
      useEffect(() => {
        statusRef.current = commonReducer.event_details?.status_type_order;
        if(statusRef.current === 4) {
          if(commonReducer.event_details.final_video_id === commonReducer.event_details.revision.revision_video_id) {
            //dispatch(updateState({new_video: false}));
            underRevisionRef.current =  commonReducer.event_details?.revision.submitted;
          } else {
            underRevisionRef.current =  false
          }
        }
    }, [commonReducer.event_details.status_type_order, commonReducer.event_details?.revision.submitted, commonReducer.event_details.final_video_id, commonReducer.event_details.revision.revision_video_id]);

    useEffect(()=> {
      finalVideoRef.current = commonReducer.event_details.final_video_id
    }, [commonReducer.event_details.final_video_id])

    useEffect(()=>{
      checkTokenSession(dispatch)
      getUserRoles(dispatch, navigate, permissionsReducer, {event_id: commonReducer?.production_event_id}, getUserCallback)
      
      // Close any open popups on mount
      dispatch(updateReviewState({open_request_changes_popup: false, open_change_request_tutorial_popup: false, revision_history_popup: false, history_preview_url: '', history_preview_version: null}))
    },[])
  
    useEffect(()=> {
      getEventDetails({id: commonReducer.production_event_id}, dispatch, navigate, { commonReducer, permissionsReducer });
      
     const intervalId = setInterval( () => {
        // Check if user is still logged in before making API calls
        if(!window.localStorage.getItem('token')) {
          clearInterval(intervalId);
          return;
        }
        if(statusRef.current == 3 || (statusRef.current == 4 && underRevisionRef.current == true)) {
          checkNewVideoArrival({event_id: commonReducer.production_event_id, final_video_id: finalVideoRef.current}, dispatch, { commonReducer, permissionsReducer })
        }
      }, 15000);
     
      return () => clearInterval(intervalId);
    
  
    },[])
  

      // useEffect(()=> {
      //   if(commonReducer.new_video == true) {
      //     refetchEventDetail()
      //   }
      // }, [commonReducer.new_video])

    // useEffect(() => {
     
    //   setUploadedVideosArray(uploadedVideos) 
    // }, [uploadedVideos])
    
  
    // useEffect(() => {
    //   refetchList();
    // }, [commonReducer.production_event_id])

    // Use a ref to prevent infinite loops when getEventDetails updates state
    const requestChangesRef = useRef(false)
    
    useEffect(()=> {
      // Only call getEventDetails if request_changes changed from false to true
      if(reviewEventReducer.request_changes === true && !requestChangesRef.current) {
        requestChangesRef.current = true
        getEventDetails({id: commonReducer.production_event_id}, dispatch, navigate, {commonReducer})
      } else if(reviewEventReducer.request_changes === false) {
        requestChangesRef.current = false
      }
    }, [reviewEventReducer.request_changes, commonReducer.production_event_id])
    
    useEffect(() => {
      const selectedEvent = commonReducer.event_details

      if (Object.keys(selectedEvent)?.length > 0) {
        // KAN-10: collab_code is deliberately not read off the event payload any
        // more. The share link comes from the gated guest_access endpoint, via
        // useGuestAccess, so a view-only member never holds one.
        setEventData({ name: selectedEvent.name, editor_start_date: selectedEvent.editor_start_date, start: selectedEvent.start_date, end: selectedEvent.end_date, eventType: selectedEvent.event_type, status: selectedEvent.status_type , consentStatus: selectedEvent.consent_accepted})
      }
// setTimeout(() => {
  
//   if(commonReducer.event_details.revision.id == null || commonReducer.event_details.revision.submitted == true) {
//     if(commonReducer.show_revision_tutorial) {
//       dispatch(updateReviewState({open_change_request_tutorial_popup : true}))
//       disableRevisionTutorialRequest(dispatch, navigate, {commonReducer})
//     }
//     createNewRevision(dispatch, navigate, {commonReducer}, {event_id: commonReducer.production_event_id, final_video_id: commonReducer.event_details.final_video_id})
//   } 
// }, 3000);

     
    }, [commonReducer.production_event_id, commonReducer.event_details.name])

    // Sync request_changes flag with revision submitted status
    useEffect(() => {
      if(commonReducer.event_details?.revision?.id) {
        const isSubmitted = commonReducer.event_details.revision.submitted === true
        const revisionForCurrentVideo = commonReducer.event_details.revision.revision_video_id === commonReducer.event_details.final_video_id
        
        console.log('🔄 Syncing request_changes:', {
          revision_id: commonReducer.event_details.revision.id,
          isSubmitted,
          revisionForCurrentVideo,
          will_show_logs: !isSubmitted && revisionForCurrentVideo
        })
        
        // Show logs panel when: revision exists for current video AND not submitted
        // Hide logs panel when: revision is submitted OR revision is for old video
        // Revision is for an older cut (a new cut was delivered after it was submitted):
        // no request is open on this cut yet, so show Accept / Request Revision
        if(revisionForCurrentVideo && !isSubmitted) {
          dispatch(updateReviewState({request_changes: true, open_request_changes_popup: false}))
        } else if(isSubmitted && revisionForCurrentVideo) {
          dispatch(updateReviewState({request_changes: false, open_request_changes_popup: false}))
        } else if(!revisionForCurrentVideo) {
          dispatch(updateReviewState({request_changes: false, open_request_changes_popup: false}))
        }
      }
    }, [commonReducer.event_details?.revision?.id, commonReducer.event_details?.revision?.submitted, commonReducer.event_details?.revision?.revision_video_id, commonReducer.event_details?.final_video_id])

    // Create revision when needed (new video or navigation from dashboard)
    useEffect(() => {
      // Wait for both event_details AND permissions to be loaded
      if(commonReducer.event_details?.final_video_id && permissionsReducer.permissions_master) {
        
        console.log('🔍 Revision check:', {
          final_video_id: commonReducer.event_details.final_video_id,
          revision_id: commonReducer.event_details.revision?.id,
          revision_video_id: commonReducer.event_details.revision?.revision_video_id,
          revision_submitted: commonReducer.event_details.revision?.submitted,
          permissions_loaded: !!permissionsReducer.permissions_master,
          has_create_permission: permissionsReducer.permissions_master?.[PERMISSION.PROJECT.REVISION.REQUEST.CREATE]
        })
        
        const needsRevision = 
          !commonReducer.event_details.revision?.id || 
          commonReducer.event_details.revision?.submitted === true ||
          commonReducer.event_details.revision?.revision_video_id !== commonReducer.event_details.final_video_id
        
        if(needsRevision) {
          console.log('✅ Creating revision for final_video_id:', commonReducer.event_details.final_video_id)
          
          // Disable tutorial without showing popup - tutorial will show when user clicks "Send for Revision"
          if(commonReducer.show_revision_tutorial) {
            disableRevisionTutorialRequest(dispatch, navigate, {commonReducer})
          }
          
          createNewRevision(dispatch, navigate, {commonReducer, permissionsReducer}, {
            event_id: commonReducer.production_event_id,
            final_video_id: commonReducer.event_details.final_video_id
          })
        } else {
          console.log('ℹ️ Revision already exists for current video')
        }
      }
    }, [commonReducer.event_details?.final_video_id, commonReducer.event_details?.revision?.revision_video_id, permissionsReducer.permissions_master])


    // const copyInvite = ()=> {
    //   setShareButtonText("COPIED!")
    //   navigator.clipboard.writeText(`Hi! ${commonReducer.user_name} has invited you to be a contributor to their event. Please visit the given link and use following invitation code to collaborate to this event\n\nInvitation Code:  ${eventData.code}\n\n\n ${window.location.host}`)
    //   setTimeout(() => {
    //     setShareButtonText("INVITE")
    //   }, 1500)
    // }
  
    const shareClickHandler = () => {
      // KAN-10: the share sheet used to hand out the raw collab code, which the
      // event payload gave to anyone who could view the project. The link now
      // comes from guest_access, so a member the server refused has nothing to
      // share and is told so instead of sharing an empty invitation.
      if (!guestReviewUrl) {
        dispatch(setSnackbar({flag: true, type: 'error', message: "You do not have permission to share this project."}))
        return
      }
      const dataToBeShared = {
       // title: "This title is for sharing",
        text: `Hi! ${commonReducer.user_name} has invited you to be a contributor to their event. Please visit the given link to collaborate on this event\n\n${guestReviewUrl}\n\n\n`,
        url: guestReviewUrl
      };
      // Check if navigator.share is supported by the browser
    // console.log(navigator.share)
      if (navigator.share) {
        navigator
          .share(dataToBeShared)
          .then(() => {
          })
          .catch(() => {
          });
      } else {
       // console.log("Sorry! Your browser does not support Web Share API");
      }
    }
  
   const getUserCallback = (permission)=>{
    if(!permission[PERMISSION.PROJECT.REVISION.PAGE_VIEW])  {
      // console.log("slected team", teamsReducer.selected_team)
       isFromTeamsDashboard? navigate('/dashboard/teams') : navigate('/dashboard')
      dispatch(setSnackbar({flag: true, type: 'error', message: "ACCESS DENIED!"}))
    } else {
      setShowPage(true)
    }
   }


   const { eventId } = useParams();
   const eventIdSetRef = useRef(false);
   const viewMembersCalledRef = useRef(false);

  useEffect(()=> {
    // Prevent loop: only set production_event_id once when eventId changes
    if(eventId && parseInt(eventId, 10) !== commonReducer?.production_event_id && !eventIdSetRef.current) {
      eventIdSetRef.current = true;
      dispatch(updateState({ production_event_id: parseInt(eventId, 10) }));
    }
    
    // Store permission check result to avoid object property access in dependency
    const canViewMembers = hasPermission(PERMISSION.PROJECT.MEMBER.VIEW);
    if(canViewMembers && commonReducer.production_event_id && !viewMembersCalledRef.current) {
      viewMembersCalledRef.current = true;
      viewProjectMembers({event_id: commonReducer.production_event_id}, dispatch, navigate, {commonReducer})
    }
  },[eventId, commonReducer?.production_event_id])
  
 
    const backCLickHandler = ()=> {
      // dispatch(updateReviewState({request_changes: false}))
      navigate(`/productionevent/${commonReducer.production_event_id}`, {replace: true})
    }

  // useEffect(()=> {
  //   if(!hasPermission(PERMISSION.PROJECT.REVISION.PAGE_VIEW) ) {
  //     console.log("slected team", teamsReducer.selected_team)
  //      !!teamsReducer.selected_team ? navigate('/dashboard/teams') : navigate('/dashboard')
  //     dispatch(setSnackbar({flag: true, type: 'error', message: "ACCESS DENIED!jakdshcbajkhda"}))
  //   }
  // }, [permissionsReducer.permissions_master, teamsReducer.selected_team])
    

  return (
  
    showPage && <AuthLayout uploadProps = {props.uploadProps} sx={{ padding: '2.5% 3.9% 2.1% 2.2%'}}>
        <Box gap={2} className='flex row a-start j-end'>
        {/* <img onClick={()=> window.location.href='https://butterfly.lucimoments.com'} src={butterfly} style={{ borderRadius: '5px', width: '190px', cursor: 'pointer'}} /> */}
                  <CustomUserCard/>
                </Box>
                <Box container className={classes.container}>
        <Box className={classes.leftContainer}>
              <Box sx={{height:{xs:'400px',sm:'400px',md:'58vh',lg:'62vh',xl:'70vh'}, marginBottom:{xs:'15px',md:'20px',lg:'23px',xl:'35px'}}}>
                 <EventDetailCard eventData={eventData}/>
              </Box>
              <Box  sx={{height:{xs:'60px',sm:'80px',md:'16.1vh',lg:'18.1vh',xl:'16.1vh'}}} >
                <FilmingTutorialCard onClick= {()=> dispatch(updateState({play_tutorial: true})) } clickable = {true} />
              </Box>
             
        </Box>
  
        <Box className={classes.rightContainer}>
              <Box sx={{width:'100%', }}>
                <Box gap={1} sx={{display:'flex', justifyContent:'space-between', alignItems:'center', color:'black' }}>
                    <Box gap={1} sx={{display:'flex', justifyContent:'start', alignItems:'center', color:'black' }}>
                      <IconButton onClick={backCLickHandler}>
                        <KeyboardBackspaceOutlinedIcon sx={{color:'black',}}/>
                      </IconButton>
                      <Typography sx={{fontFamily: 'Rubik', fontSize:{xs:'10px',sm:'11px',md:'12px',lg:'14px',xl:'20px'}}}>{backButtonTitle}</Typography>
                    </Box>
                    {/* The standalone Revision History popup is hidden for now - versions
                        are picked on the strip under the player in the card below. */}
                </Box>
              </Box>
  
              <Box style={{display:'flex', gap:'2.34%'}} sx={{ marginBottom:{xs:'15px',sm:'15px',md:'15px',lg:'20px',xl:'30px'},  marginTop:{xs:'8px', sm:'10px', md:'12px',lg:'14px',xl:'23px'}, width:'100%', }}>

                  <Box sx={{height:{xs:'82px',sm:'82px', md:'98px',lg:'15.5vh',xl:'16vh'}, width:'26%'}} container  >
                      {/* <CollaboratorCard shareClickHandler={shareClickHandler} isDisabled = {commonReducer?.event_details?.status_type == 'Complete' || commonReducer?.event_details?.status_type == 'Review'} /> */}
                      <ProjectMembersCard
                        //  getFirstLetters={getFirstLetters} 
                         shareClickHandler={shareClickHandler} 
                        //  copyInvite={copyInvite} 
                         buttonState={shareButtonText} 
                         isDisabled = {!hasPermission(PERMISSION.PROJECT.MEMBER.VIEW)}
                      />
                  </Box>
                  <Box sx={{height:{xs:'82px',sm:'82px', md:'98px',lg:'15.5vh',xl:'16vh'}, width:'74%'}} container>
          
                           { 
                              commonReducer?.event_details?.status_type == 'Complete' ?  <FinalVideoCompletedCard/> : 
                               ( reviewEventReducer.request_changes ? <SubmitChangeRequestCard/> : 
                                   ( commonReducer.event_details?.revision?.submitted == true && commonReducer.event_details?.final_video_id == commonReducer.event_details?.revision?.revision_video_id ? <ReEditingStartedCard /> :         
                                        <VideoEditedCompletedCard message = {commonReducer?.event_details?.revision?.id == null || commonReducer?.event_details?.revision?.submitted != true ? "Your Lucivideo is ready!" : "Updates have been made to your Lucivideo."} />
                                   )
                               )
                           }
                           
                  </Box>
              </Box>
  {/* /////////////////main box for review stage//////////////////////// */}
              <RevisionReviewCard uploadProps={uploadProps} />
        
        </Box>  
        </Box> 
        {
            commonReducer.play_tutorial == true && <PopupVideoPlayer />
       }
       {reviewEventReducer.open_change_request_tutorial_popup == true && <SubmitChangeRequestTutorialPopup />}

       {reviewEventReducer.revision_history_popup == true && <RevisionHistoryPopup />}
              
       {projectReducer.invite_project_members_popup == true && <InviteProjectMembersPopup/>}

       {projectReducer.view_project_members_popup == true && <ViewProjectMembersPopup />}

       {projectReducer.assign_owner_popup == true && <AssignOwnerPopup/>}

       {projectReducer.remove_user_confirmation_popup == true && <RemoveUserConfirmationPopup/>}

       {projectReducer.remove_owner_popup == true && <RemoveOwnerPopup/>}

       {projectReducer?.upload_documents_to_editor_popup && <UploadDocumentsPopup uploadProps = {uploadProps} />}

       {projectReducer?.upload_song_popup && <UploadSongPopup uploadProps = {uploadProps}/>}

     </AuthLayout> 

  )
}

export default CompletedEventPage